import React, { useState } from "react";
import { useParams } from "react-router-dom";
import MainNavbar from "../../pages/MainNavbar";
import Footer from "../footers";
import ProductFiltersWithList from "./ProductFiltersWithList";
import { useAuth } from "../../context/AuthContext";
import "./CategoryPage.css";
import Breadcrumbs from "../Breadcrumbs";

const CategoryPage: React.FC = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const { currentUser } = useAuth();
  const [showSubnav, setShowSubnav] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const isLoggedIn = !!currentUser;
  const userId = currentUser?.id ?? "guest";


  return (
    <div className="category_wrapper">
      <MainNavbar
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        isLoggedIn={isLoggedIn}
        showSubnav={showSubnav}
        setShowSubnav={setShowSubnav}
     
        userId={userId}
      />
      <Breadcrumbs />

      <ProductFiltersWithList
        categoryId={categoryId || ""}
        searchQuery={searchQuery}
      />

      <Footer />
    </div>
  );
};

export default CategoryPage;